<div class="region-selector-wrapper" (click)="toggleDropdown()" (mouseleave)="mouseLeave()">
  <div class="region-selector-container">
    <mm-icon class="region-selector-container__location-icon" name="location"></mm-icon>
    <div class="region-select-wrapper">
      <div class="custom-select">
        <div class="selected-option">{{ selectedRegion }}</div>
        <div class="options" [class.open]="isOpen">
          <div *ngIf="mobileSidenavMenu" class="options-header">
            <a (click)="closeOptions($event)"
              ><mm-icon name="cross-ico"></mm-icon>{{ 'CLOSE_REGION_SELECTION_OPTIONS' | translate }}</a
            >
            <span class="options_title">{{ 'CHOOSE_A_REGION' | translate }}</span>
          </div>
          <div class="options-body">
            <div
              class="option"
              [ngClass]="{ 'bg-blue': mobileSidenavMenu && selectedRegion === region.name }"
              *ngFor="let region of regionsList"
              (click)="setRegionSelected(region, $event)"
            >
              <div>
                <span class="primary-blue-text bold">{{ region.name }}</span>
                <span class="region-delivery-text">{{
                  'REGION_SELECTOR_DELIVERY_OFFERS_TEXT' | translate: { region: region.name }
                }}</span>
              </div>
              <mm-icon
                *ngIf="selectedRegion === region.name"
                class="selected-option__check-icon"
                name="check-mark-small"
              ></mm-icon>
            </div>
          </div>
        </div>
        <div
          *ngIf="isOpen && mobileSidenavMenu"
          class="region_selector_options__overlay"
          (click)="closeOptions($event)"
        ></div>
      </div>
    </div>
    <mm-icon
      class="region-selector-container__arrow-icon"
      [ngClass]="{ 'rotate-up': isOpen }"
      name="chevron-down-blue"
    ></mm-icon>
  </div>
  <div
    class="vertical-divider"
    *ngIf="!mobileSidenavMenu"
    class="vertical-divider-v2"
  ></div>
</div>
